// extracted by mini-css-extract-plugin
module.exports = {"form":"editUserGroupForm_form__vYZtt","saveButton":"editUserGroupForm_saveButton__3w91J buttons_success__3M0iK buttons_button__1BbpB"};